<script>
    import VideoChat from './components/VideoChat.svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    let inviteAccepted = false;

    function declineInvite(){
        dispatch('declined', {
            text: 'No thanks.'
        });
    }

</script>

<div id="container">
    {#if inviteAccepted}
        <VideoChat on:close/>
        {:else}
            <div>
                Hey! Dwane wants to invite you to a video call.
                <br><br><button on:click={() => inviteAccepted = true}>Accept</button> &nbsp; &nbsp; <button on:click={declineInvite}>Decline</button>
            </div>
    {/if}
</div>

<style>
    #container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        max-width: 1500px;
        margin: auto;
    }

    button {
        cursor: pointer;
    }
</style>